import { EmailApi } from "@/service/EmailApi";

export default class EmailHelper {

  static async sendEmail(tenantName: string, name: string, email: string, phonePrefix: string, phone: string){
    await EmailApi.sendEmail(tenantName, name, email, phonePrefix, phone)
  }

}
